module.exports = __webpack_public_path__ + "img/ring_y_c_0_null@2x.f416dd36.png";